import { AbstractControl, ValidationErrors } from '@angular/forms';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

/**
 *@description
 * Check that project
 * name is valid
 * @params {any} check
 * @return {any}
 * @function
 */
export const projectNameValid = function (check) {
  return (control: AbstractControl): ValidationErrors | null => {
    return check(control.value.projectName).pipe(
      map(res => {
        if (!res) return null;
        const { notUnique, toBigNameVersion, message } = <any>res;
        if (notUnique && control.value.saveAsNewProject)
          return { notUnique: true, notUniqueMsg: message };
        if (toBigNameVersion) return { toBigNameVersion: true, toBigNameVersionMsg: message };
        return null;
      }),
      catchError(err => {
        console.log('err', err);
        return of(null);
      })
    );
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-save/form-validators/project-name-valid.ts